import React from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/mortuary-banner.png';
import '../styles/pages.css';

function Mortuary() {
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Caritas Mortuary Services</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Compassionate and dignified mortuary care for families in 
                            <br/>
                            times of loss.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                        Compassionate and dignified mortuary care for families in times of loss.
                        </p>
                    </div>

                    <div className="page-box">
                        <div className="box-content">
                            <p>Caritas Mortuary Services offers compassionate and dignified care for families during times of loss. With professionalism and respect, we provide comprehensive mortuary services, including preparation, viewing arrangements, and coordination of final arrangements.Our team ensures a meaningful farewell with sensitivity and understanding.</p>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Clinical Nutrition" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='page-content'>
                    <p className='page-content-heading'>
                        Saying Goodbye with Grace and Understanding <br />
                        at Caritas Matha Hospital
                    </p>
                    <br />
                    <div className='page-details'>
                        <p>In times of grief and loss, our mortuary service at Caritas Matha Hospital stands as a beacon of comfort and respect. We understand the importance of honoring diverse cultural and religious traditions when saying goodbye to departed loved ones. Our dedicated mortuary service team ensures that every individual is treated with the utmost care, dignity, and sensitivity.</p>
                        <br />
                        
                        <h5>Services and Contact Information : </h5>
                        <br />
                        <ul>
                            <li><p>Compassionate Care: Our team provides compassionate support to families during times of bereavement, ensuring sensitivity to cultural and religious practices.</p></li>
                            <br />

                            <li><p>Careful Handling: We handle all aspects of mortuary services with meticulous attention to detail and respect for individual wishes.</p></li>
                            <br />

                            <li><p>Contact Information: For more information or assistance, please contact us at <a href='tel:0481 27900 25-29'>0481 27900 25-29</a> or <a href='+91 8547190028'>8547190028 (Mobile).</a></p></li>
                            <br />
                        </ul>

                        <p>At Caritas Matha Hospital, we are committed to providing a supportive environment where families can find solace and closure, knowing that their loved ones are treated with the utmost care and reverence.</p>
                        <br />
                    </div>
                </div>

                <div className="more-services">
                    <p className="more-services-heading">More Services</p>
                    <div className='more-services-links'>
                        <a href="/radiology-laboratory"><p> Radiology & Laboratory</p></a>
                        <a href="/blood-bank"><p> Blood Bank</p></a>
                        <a href="/clinical-nutrition"><p> Clinical Nutrition</p></a>
                        <a href="/insurance-partners"><p> Insurance Partners</p></a>
                        <a href="/pastoral-care"><p> Pastoral Care</p></a>
                        <a href="/caritas-home-care"><p> Caritas Home Care</p></a>
                        <a href="https://www.caritashospital.org/health-checkup-packages"><p> Health Checkup Packages</p></a>
                        <a href="/video-consultation"><p> Video Consultation</p></a>
                    </div>
                </div>
            </section>

            {/* Page content ends here */}

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default Mortuary;